import type { IxcMfrecoV1PositionDayKeys, IxcMutualfundsV1FundVenue } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const MFRECO_POSITION_DAY_BASE_PATH = getResolvedPath('/clearing/operations/mutualfunds/reconciliation/position-day');

export const getMfRecoPositionDayPath: EntityPathBuilder<IxcMfrecoV1PositionDayKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return MFRECO_POSITION_DAY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId && !context?.keys?.date && !context.keys?.venue) {
        return undefined;
      }

      if (context.keys?.venue && !context.keys?.date && !context.keys?.assetId) {
        return getResolvedPath(`${MFRECO_POSITION_DAY_BASE_PATH}/$venue`, context?.keys);
      }

      if (context.keys?.venue && context.keys?.date && !context.keys?.assetId) {
        return getResolvedPath(`${MFRECO_POSITION_DAY_BASE_PATH}/$venue/$date`, context?.keys);
      }

      if (context.keys?.venue && context.keys?.date && context.keys?.assetId) {
        return getResolvedPath(`${MFRECO_POSITION_DAY_BASE_PATH}/$venue/$date/$assetId`, context?.keys);
      }

      return undefined;
    }
  }
};

export function getMfRecoPositionDayDetailPath(venue: IxcMutualfundsV1FundVenue | undefined, date: string | undefined, assetId: string | undefined) {
  if (!assetId || !date || !venue) {
    return undefined;
  }

  return getMfRecoPositionDayPath({ kind: 'detail', keys: { assetId, date, venue } });
}
